import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';
import registerServiceWorker from './registerServiceWorker';
import { Provider } from 'react-redux';
import { store, actions, getState } from './store/index';

const NebPay = require('nebpay');

const nebPay = new NebPay();

// Global (context) variables that can be easily accessed from any React component
// https://facebook.github.io/react/docs/context.html
const context = {
  // Enables critical path CSS rendering
  // https://github.com/kriasoft/isomorphic-style-loader
  nebPay,
  actions,
  getState,
};

window.postMessage(
  {
    target: 'contentscript',
    data: {},
    method: 'getAccount',
  },
  '*',
);
window.addEventListener('message', (e) => {
  // e.detail contains the transferred data (can
  if (!!e.data && !!e.data.data && !!e.data.data.account) {
    actions.setAccount(e.data.data.account);
    // console.log('e.data', JSON.stringify(e.data));
  }
});

ReactDOM.render(
  <Provider store={store}>
    <App context={context}/>
  </Provider>,
  document.getElementById('root'),
);
// module.hot.accept();
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js